import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ORGANISATION_DEFAULTS } from "utils/constants";
import { makeStyles } from "@mui/styles";
import CompanyLogo from "components/icons/CompanyLogo";
import useIsMobile from "utils/helpers/mediaQueryHelper";

const styles = {
    root: {
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginBottom: 20
    }
};

const useStyles = makeStyles(styles);

export default function LoginHeader() {
    const classes = useStyles();
    const isMobile = useIsMobile();
    return (
        <Box textAlign="center" mb={4} className={classes.root}>
            {isMobile && (
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    color={"text.primary"}
                >
                    {ORGANISATION_DEFAULTS.orgName}
                </Typography>
            )}
            <CompanyLogo />

            <Typography variant="body1" color="text.secondary">
                {ORGANISATION_DEFAULTS.appName}
            </Typography>
        </Box>
    );
}
